export const DEFAULT_BOOKING_CHECK_IN_SETTINGS = {
  allowClientCheckIn: false,
  automatedCheckInReminderEnabled: false,
  checkInReminderSendSms: false,
  checkInReminderSendEmail: false,
  checkInWindowMinutesBefore: 30,
  requireClientConfirmedBeforeCheckIn: false,
};
